import React, { Component } from 'react'
import { Spinner, DetailsList, SelectionMode, FontIcon, ScrollablePane, mergeStyleSets } from 'office-ui-fabric-react';
import { Query } from 'react-apollo';
import { MyContext } from '../../../../../context';
import { getScorecardResults, getGroupListForLoggedUser, exportScorecardResult } from '../../../../ComplianceView/AIQualityManagement/AIQualityManagementQuery';
import AlertBar from '../../../../CustomComponents/AlertBar';
import ScorecardResult from './ScorecardResult';
import * as utils from "./ScorecardResultUtils"
import AIDisclaimer from '../../../../common/AIDisclaimer';


export default class AIQualityManagementResult extends Component {

    static contextType = MyContext

    constructor(props) {
        super(props);

        this.state = {
            isProcessing: false,
            showDetail: false,
            scorecardResultId: null,
            userGroups: []
        };
    }

    componentDidMount() {
        this.props.apol
            .query({
                query: getGroupListForLoggedUser
            })
            .then((result) => {
                this.setState({ userGroups: result.data.getGroupListForLoggedUser })
            })
    }

    refetchQueryScorecardsResult = null

    renderItemColumn = (item, index, column) => {
        //console.log(item, index, column)

        let totalScore = utils.getTotalScore(item)
        let totalPoints = utils.getTotalPoints(item)
        let rangeEvaluation = utils.getRangeEvaluation(item, totalScore, totalPoints)

        const fieldName = column.fieldName
        switch (fieldName) {
            case "automatedEvaluation": {
                return <span>{item.automatedEvaluation ?
                    this.context.getTranslation("compliance", "automated") :
                    this.context.getTranslation("compliance", "manual")}
                </span>
            }
            case "assessment": {
                return <span>{`${totalScore}/${totalPoints}`}</span>
            }
            case "evaluationKey": {
                return <span>{rangeEvaluation?.name}</span>
            }
            default: return <span>{item[fieldName]}</span>
        }
    }

    onActiveItemChanged = (item) => {
        this.setState({ showDetail: true, scorecardResultId: item.id })
    };

    render() {
        const iconStyle = {
            display: 'block',
            textAlign: 'left',
            color: "yellow"
        }
        const classNames = mergeStyleSets({
            wrapper: {
                height: this.props.height,
                position: 'relative',
                minHeight: '100px'
            },
            pane: {
            }
        });
        return <div>
            <div className={classNames.wrapper}>
                <ScrollablePane styles={{ root: classNames.pane }}>
                    <Query
                        query={getScorecardResults}
                        variables={{
                            conversationId: this.props.data.conversationId
                        }}
                    >
                        {({ loading, error, data, refetch }) => {
                            this.refetchQueryScorecardsResult = refetch;
                            if (loading) { return <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" /> }
                            if (error) {
                                console.log(error)
                                return <AlertBar message={this.context.getTranslation("compliance", "error")} alertType="error" />
                            }
                            if (data.getScorecardResults == null || data.getScorecardResults.length === 0) {
                                return <AlertBar message={this.context.getTranslation("compliance", "noData")} alertType={"warning"} />
                            }
                            if (data.getScorecardResults.length === 1) {
                                return (
                                    <ScorecardResult
                                        conversationId={this.props.data.conversationId}
                                        scorecardResult={data.getScorecardResults[0]}
                                        userGroups={this.state.userGroups}
                                        showButtonCancel={false}
                                        apol={this.props.apol}
                                        refreshResult={() => { this.refetchQueryScorecardsResult() }}
                                        userRules={this.props.userRules}
                                    />
                                )
                            } else {
                                var columns = [
                                    {
                                        key: 'scorecardName',
                                        name: this.context.getTranslation("compliance", "name"),
                                        fieldName: 'scorecardName',
                                        minWidth: 100,
                                        maxWidth: 150,
                                        isResizable: true
                                    },
                                    {
                                        key: "automatedEvaluation",
                                        name: this.context.getTranslation("compliance", "evaluationType"),
                                        fieldName: "automatedEvaluation",
                                        minWidth: 100,
                                        maxWidth: 150,
                                        isResizable: true
                                    },
                                    {
                                        key: "assessment",
                                        name: this.context.getTranslation("compliance", "assessment"),
                                        fieldName: "assessment",
                                        minWidth: 100,
                                        maxWidth: 150,
                                        isResizable: true
                                    },
                                    {
                                        key: "evaluationKey",
                                        name: this.context.getTranslation("compliance", "evaluationKey"),
                                        fieldName: "evaluationKey",
                                        minWidth: 100,
                                        maxWidth: 150,
                                        isResizable: true
                                    }
                                ]
                                // Add warning icon if there are manual QM questions with score -2
                                let warningIconRes = data.getScorecardResults.filter(s => s.automatedEvaluation).some(s => s.sections.some(section => section.evaluationItems.some(el => el.itemType === "ManualQMQuestions" && el.score === -2)))
                                if (warningIconRes) {
                                    columns = [...columns,
                                    {
                                        key: "WarningManualQM",
                                        fieldName: "WarningManualQM",
                                        minWidth: 100,
                                        maxWidth: 150,
                                        isResizable: true,
                                        onRender: (item, i) => {
                                            const ret =
                                                item.automatedEvaluation &&
                                                item.sections.some(section =>
                                                    section.evaluationItems.some(el =>
                                                        el.itemType === "ManualQMQuestions" && el.score === -2
                                                    )
                                                );
                                            if (ret) {
                                                return <span style={iconStyle}>{<FontIcon iconName="WarningSolid" style={{ fontSize: "20px" }} title="Warning" />}</span>;
                                            } else {
                                                return "";
                                            }
                                        }
                                    }]
                                }
                                return (
                                    <div style={{ marginTop: 10 }}>
                                        {!this.state.showDetail &&
                                            <DetailsList
                                                items={data.getScorecardResults}
                                                columns={columns}
                                                selectionMode={SelectionMode.none}
                                                onActiveItemChanged={this.onActiveItemChanged}
                                                setKey="set"
                                                onRenderItemColumn={this.renderItemColumn}
                                            />
                                        }
                                        {this.state.showDetail &&
                                            <ScorecardResult
                                                conversationId={this.props.data.conversationId}
                                                apol={this.props.apol}
                                                showButtonCancel={true}
                                                closeDetail={() => { this.setState({ showDetail: false }) }}
                                                scorecardResult={data.getScorecardResults.filter(s => s.id === this.state.scorecardResultId)[0]}
                                                refreshResult={() => { this.refetchQueryScorecardsResult() }}
                                                userRules={this.props.userRules}
                                                userGroups={this.state.userGroups}
                                            />
                                        }
                                    </div>
                                )
                            }

                        }}
                    </Query>
                </ScrollablePane>
            </div>
            <AIDisclaimer theme={this.props.theme} />
        </div>
    }
}